import PropTypes from 'prop-types'
import { Input } from 'baseui/input'
import { Radio, RadioGroup } from 'baseui/radio'
import { Datepicker } from 'baseui/datepicker'
import { Select } from 'baseui/select'
import { AssignmentChoice, FormWrapper, TwoCols } from './styled-components'
import { toSelectValue, idFromSelectValue } from '@/shared/tools/optionsToArray'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'

const ScheduleCallbackForm = ({
  t,
  values,
  handlers,
  selects,
  hasUpcoming,
  allowedVerticals,
  showAssignmentChoice = true,
}) => {
  const hourValue = toSelectValue(selects.hourOptions, values.hour)
  const minValue = toSelectValue(selects.minuteOptions, values.minutes)

  return (
    <FormWrapper>
      <SDSelect
        label={mandatoryTag + t('subscriptionTools:schedule_callback.label_vertical')}
        optionsList={allowedVerticals}
        onChangeHandler={selected => handlers.setBusinessVertical(selected.value[0]?.id || '')}
        selectedValue={values.businessVertical}
        translationsPath='subscriptionTools:schedule_callback.verticals.'
        newTranslations={true}
      />
      <TwoCols>
        <Input
          disabled={hasUpcoming}
          value={values.firstName}
          onChange={e => handlers.setFirstName(e.target.value)}
          placeholder={t('subscriptionTools:schedule_callback.label_surname')}
          clearOnEscape
        />
        <Input
          disabled={hasUpcoming}
          value={values.lastName}
          onChange={e => handlers.setLastName(e.target.value)}
          placeholder={t('subscriptionTools:schedule_callback.label_name')}
          clearOnEscape
        />
      </TwoCols>

      <TwoCols>
        <Input
          disabled={hasUpcoming}
          value={values.phone}
          onChange={e => handlers.setPhone(e.target.value)}
          placeholder={t('subscriptionTools:schedule_callback.label_phone')}
          clearOnEscape
        />
        <Input
          disabled={hasUpcoming}
          value={values.email}
          onChange={e => handlers.setEmail(e.target.value)}
          placeholder={t('subscriptionTools:schedule_callback.label_email')}
          clearOnEscape
        />
      </TwoCols>

      <TwoCols>
        <Datepicker
          disabled={hasUpcoming}
          value={values.date}
          onChange={({ date }) => handlers.setDate(Array.isArray(date) ? date : [date])}
          placeholder={t('subscriptionTools:schedule_callback.label_date')}
          minDate={new Date()}
          range={false}
        />
        <TwoCols>
          <Select
            disabled={hasUpcoming}
            options={selects.hourOptions}
            value={hourValue}
            placeholder={t('subscriptionTools:schedule_callback.label_time')}
            onChange={({ value }) => handlers.setHour(idFromSelectValue(value))}
            clearable={false}
          />
          <Select
            disabled={hasUpcoming}
            options={selects.minuteOptions}
            value={minValue}
            placeholder={t('subscriptionTools:schedule_callback.label_time_min')}
            onChange={({ value }) => handlers.setMinutes(idFromSelectValue(value))}
            clearable={false}
          />
        </TwoCols>
      </TwoCols>

      <AssignmentChoice hidden={!showAssignmentChoice}>
        <RadioGroup
          disabled={hasUpcoming}
          align='horizontal'
          value={values.assigned}
          onChange={e => handlers.setAssigned(e.target.value)}
        >
          <Radio value='self'>{t('subscriptionTools:schedule_callback.label_self_agent_option')}</Radio>
          <Radio value='first'>{t('subscriptionTools:schedule_callback.label_available_agent_option')}</Radio>
        </RadioGroup>
      </AssignmentChoice>
    </FormWrapper>
  )
}

ScheduleCallbackForm.propTypes = {
  t: PropTypes.func.isRequired,
  allowedVerticals: PropTypes.array.isRequired,
  values: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.array]),
    hour: PropTypes.string,
    minutes: PropTypes.string,
    assigned: PropTypes.string,
    businessVertical: PropTypes.string,
  }).isRequired,
  handlers: PropTypes.shape({
    setBusinessVertical: PropTypes.func,
    setFirstName: PropTypes.func,
    setLastName: PropTypes.func,
    setPhone: PropTypes.func,
    setEmail: PropTypes.func,
    setDate: PropTypes.func,
    setHour: PropTypes.func,
    setMinutes: PropTypes.func,
    setAssigned: PropTypes.func,
  }).isRequired,
  selects: PropTypes.shape({
    hourOptions: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })).isRequired,
    minuteOptions: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })).isRequired,
  }).isRequired,
  hasUpcoming: PropTypes.bool,
  showAssignmentChoice: PropTypes.bool,
}

export default ScheduleCallbackForm
